﻿<script setup>
    const props = defineProps({
        secured: String,
    });
</script>

<template>
    <q-page bg-slate-100>
        <div class="pt-[58px]" px-2>
            <slot></slot>
        </div>
    </q-page>
</template>

<style lang="scss">
</style>